import { render } from "./ModalPaymentChannels.vue?vue&type=template&id=bed242e2&scoped=true&ts=true"
import script from "./ModalPaymentChannels.vue?vue&type=script&lang=ts"
export * from "./ModalPaymentChannels.vue?vue&type=script&lang=ts"

import "./ModalPaymentChannels.vue?vue&type=style&index=0&id=bed242e2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed242e2"]])

export default __exports__